import PropTypes from 'prop-types'
import classNames from 'classnames'

import RawHTML from '../../../common/raw-html'
import Reader from './reader'
import Player from './player'
import { useBreakpoint } from '../../../../hooks/breakpoint'
import { KIND_AUDIO, KIND_COLOR_MAP } from '../constants'
import Icon from '../../../common/icon'
import Share from '../../share/simple'
import UserIcon from '../../icon/user.svg'
import Typography from '../../typography'
import Download from '../action/download'
const Details = ({ resource, ...attrs }) => {
  const breakpoint = useBreakpoint()
  const hasEmbedCode = !!resource.embedCode
  const kindColor = KIND_COLOR_MAP[resource.kind]

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'pt-8',
      'pb-10',
      'md:pt-12',
      'md:pb-16',
      'md:bg-white'
    ]
  )

  return <section
    {...attrs}>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames(
            [
              'flex',
              'flex-row',
              'flex-wrap',
              'items-start',
              '-mx-4'
            ]
          )
        }>
        <div
          className={
            classNames([
              'relative',
              'px-4'
            ])
          }
          style={{
            width: breakpoint.lgAndUp ? '30%' : (breakpoint.mdAndUp ? '30%' : '100%'),
            flexBasis: breakpoint.lgAndUp ? '30%' : (breakpoint.mdAndUp ? '30%' : '100%')
          }}>
          <div
            className={
              classNames(
                [
                  'grid',
                  'grid-cols-1',
                  'gap-8',
                  'mb-8'
                ]
              )
            }>
            {
              resource.resourceAuthors.length > 0
                ? <div>
                  {
                    resource.resourceAuthors.map(
                      resourceAuthor => {
                        return <div
                          key={resourceAuthor.id}
                          className={
                            classNames(
                              [
                                'flex',
                                'items-center'
                              ]
                            )
                          } >
                          {
                            resourceAuthor.author.picture
                              ? <div
                                className={
                                  classNames(
                                    [
                                      'h-12',
                                      'w-12',
                                      kindColor,
                                      'text-white',
                                      'rounded-full',
                                      'mr-4',
                                      'bg-cover',
                                      'bg-center'
                                    ]
                                  )
                                }
                                style={{
                                  backgroundImage: `url(${resourceAuthor.author.picture.meta.downloadUrl})`
                                }} />
                              : <Icon
                                size={48}
                                svg={UserIcon}
                                className={
                                  classNames(
                                    [
                                      'h-12',
                                      'w-12',
                                      kindColor,
                                      'text-white',
                                      'rounded-full',
                                      'mr-4'
                                    ]
                                  )
                                } />
                          }
                          <Typography>
                            {resourceAuthor.author.fullName}
                          </Typography>
                          <Typography>
                            <small>{resourceAuthor.author.ocupation}</small>
                          </Typography>
                        </div>
                      }
                    )
                  }
                </div>
                : null
            }
            {
              resource.kind === KIND_AUDIO && breakpoint.mdAndUp
                ? <Download
                  resource={resource} />
                : null
            }
            <Share
              url={`/recursos/${resource.id}/${resource.meta.slug}`} />
          </div>
        </div>
        <div
          className={
            classNames(
              [
                'relative',
                'px-4'
              ]
            )
          }
          style={{
            width: breakpoint.lgAndUp ? '70%' : (breakpoint.mdAndUp ? '70%' : '100%'),
            flexBasis: breakpoint.lgAndUp ? '70%' : (breakpoint.mdAndUp ? '70%' : '100%')
          }}>
          {
            hasEmbedCode
              ? (resource.kind === KIND_AUDIO)
                ? <Player
                  className={'mb-6'}
                  resource={resource} />
                : <Reader
                  className={'mb-6'}
                  resource={resource} />
              : null
          }
          <RawHTML html={resource.summary} />
        </div>
      </div>
    </div>
  </section>
}

Details.propTypes = {
  resource: PropTypes.object
}

export default Details
